import { render, staticRenderFns } from "./AppSidebarComercial.vue?vue&type=template&id=4dd47d41&scoped=true"
import script from "./AppSidebarComercial.vue?vue&type=script&lang=js"
export * from "./AppSidebarComercial.vue?vue&type=script&lang=js"
import style0 from "./AppSidebarComercial.vue?vue&type=style&index=0&id=4dd47d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd47d41",
  null
  
)

export default component.exports